import { API_META } from '../api/beehive-api.service';
import { ApiResponseMeta } from '../api/api.interfaces';

export const getPageMetadata = <T extends unknown>(
  subject: T[],
): ApiResponseMeta => Reflect.getMetadata(API_META, subject);
export const setPageMetadata = <T extends object>(
  target: T,
  metadata: Partial<ApiResponseMeta>,
) => {
  Reflect.defineMetadata(API_META, metadata, target);
  return target;
};

export function getInstanceOrClassMetadata(
  target: unknown,
  metadataKey: string | symbol,
) {
  if (
    (typeof target !== 'object' && typeof target !== 'function') ||
    target === null
  ) {
    return undefined;
  }
  try {
    const myFields =
      Reflect.getMetadata(metadataKey, target) ??
      Reflect.getMetadata(metadataKey, target.constructor);
    if (myFields !== undefined) {
      return myFields;
    }
  } catch {}
  const proto = Reflect.getPrototypeOf(target);
  if (proto) {
    return Reflect.getMetadata(metadataKey, proto.constructor) ?? {};
  } else {
    return undefined;
  }
}
